import React from "react";
import WorkerEquipmentTable from "./components/WorkerEquipmentTable";

export default function WorkerEquipment() {
  return (
    <div className="grid h-full min-h-0 grid-cols-1 gap-5">
      <WorkerEquipmentTable />
    </div>
  );
}


